import script from "./consulting.vue?vue&type=script&setup=true&lang=js"
export * from "./consulting.vue?vue&type=script&setup=true&lang=js"

import "./consulting.vue?vue&type=style&index=0&id=3980baa5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3980baa5"]])

export default __exports__